import { api, config } from '../../../helpers/api';
import { generatePath } from 'react-router-dom';

const KudosLike = '/kudos_like/:id';

export async function deleteLikeRequest({ id }) {
  return await api.delete(generatePath(KudosLike, { id }), config('json'));
}

export async function likeRequest({ id }) {
  return await api.post(generatePath(KudosLike, { id }), {}, config('json'));
}
